import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    selectInput: {
      marginTop: theme.spacing(12),
    },
    modalButton: {
      marginTop: theme.spacing(24),
      textTransform: "capitalize",
    },
  }),
);
